

















































































































import Vue from 'vue';
import PopMenu from '../PopMenu/PopMenu.vue';
import MoreMenu from '../MoreMenu/MoreMenu.vue';
import { DEFAULT_SEVERITIES } from '../SeverityIcon/SeverityModel';
import SeverityIcon from '../SeverityIcon/SeverityIcon.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BadgeMenuNotification from '../BadgeMenuNotification.vue';
import SeverityInterface from '../SeverityIcon/SeverityInterface';
import { PopMenuItemInterface } from '../../../common-vue-components';

/**
 * @displayName q-app-bar
 **/
@Component({
    name: 'q-app-bar',
    components: {
        MoreMenu,
        PopMenu,
        SeverityIcon,
        BadgeMenuNotification,
    },
})
export default class AppBar extends Vue {
    /**
     * Pass corplink link here
     */
    @Prop(String)
    public readonly corplink?: string;
    /**
     * Pass corplinkInNewTab boolean here
     */
    @Prop(Boolean)
    public readonly corplinkInNewTab?: boolean;
    /**
     * Data format is menuItems: [{ title: 'Sample Item 1', icon: 'mdi-view-dashboard-outline', link: 'host_dashboard' }
     */
    @Prop(Array)
    public readonly leftMenuItems?: [];
    /**
     * Data format is rightMenuItems: [{ title: 'Sample Item 1', icon: 'mdi-view-dashboard-outline',
     *                   link: 'host_dashboard', tooltip?: 'Some text' }
     */
    @Prop(Array)
    public readonly rightMenuItems?: [];
    /**
     * Data format is branding:
     * { logo: 'logo.png', name: 'quantum', logoMini: 'logo-mini.png', logoSubHeader: '', login: {} }
     * For more information please see brand.config.json in public folder
     */
    @Prop(Object)
    public readonly branding?: {};
    /**
     * Choose to display more menu or not. More menu contains About, Tooltips and Theme controls
     */
    @Prop(Boolean)
    public readonly showMoreMenu?: boolean;
    /**
     * Choose to display tooltips control within more menu or not.
     */
    @Prop({default: true, type: Boolean})
    public readonly showToolTips?: boolean;
    /**
     * Menu items for the PopMenu component
     */
    @Prop(Array)
    public readonly popMenu?: PopMenuItemInterface[];
    /**
     * Notifications  for the moreMenu component
     */
    @Prop(Object)
    public readonly moreMenuNotifications?: {};
    /**
     * More menu items
     */
    @Prop(Array)
    public readonly moreMenuItems?: [];
    /**
     * Pass feedback link here
     */
    @Prop(String)
    public readonly feedback?: string;

    /**
     * Pass feedbackType here
     */
    @Prop({default: false, type: Boolean})
    public readonly showFeedbackInModal?: boolean;

    /**
     * Function to call when the minify icon is clicked. Default to an empty function (NOP)
     */
    @Prop({
        default: () => undefined,
        type: Function,
    })
    public readonly minifyFxn?: () => void;
    /**
     * Whether the menu is minified or not - defaults to false
     */
    @Prop({default: false, type: Boolean})
    public readonly minify?: boolean;
    /**
     * Pass help link here
     */
    @Prop(String)
    public readonly externalHelp?: string;
    /**
     * Pass support link here
     */
    @Prop(String)
    public readonly support?: string;
    /**
     * Pass supportInNewTab boolean here
     */
    @Prop(Boolean)
    public readonly supportInNewTab?: boolean;
    /**
     * Pass user name here
     */
    @Prop(String)
    public readonly userName?: string;
    /**
     * Function to enable/disable tooltips.  If not defined, the control is not shown in the MoreMenu
     */
    @Prop(Function)
    public readonly tooltipChangeFxn?: (val: boolean) => void | undefined;
    /**
     * Route to go to when about menu clicked.  If undefined, no about menu item shown.
     */
    @Prop([Object, String])
    public readonly aboutRoute?: { name: string; param?: object } | string;
    /**
     * Pass in theme state here
     */
    @Prop({default: false, type: Boolean})
    public readonly theme?: boolean;
    /**
     * Choose to display global search icon or not.
     */
    @Prop({ type: Boolean, required: false, default: false })
    public readonly showIconGlobalSearch?: false;
    /**
     * Function to change the theme - false == light, true == dark
     * If not defined, the theme change control does not shown in the MoreMenu
     */
    @Prop(Function)
    public readonly themeChangeFxn?: (val: boolean) => void | undefined;
    @Prop({ type: Boolean, required: false, default: false })
    public readonly showQuantumLink?: false;
    @Prop({ type: Boolean, required: false, default: false })
    public readonly showExportLicense?: false;
    /**
     * Stornext external link
     */
    @Prop(Object)
    public readonly stornextLink?: {};

    public drawer: boolean = true;
    public routePath: string = '';
    public severities: SeverityInterface = DEFAULT_SEVERITIES;
    public menu_key: string = 'key';

    @Watch('$route')
    public onChangeRoute(to: any, from: any) {
        this.routePath = to.path;
    }


    public mounted(): void {
        this.routePath = this.$route.path;
    }

    public get logoMini(): string {
        const themePath: string = this.$vuetify.theme.dark ? 'dark' : 'light';

        return require('../../../public/static/themes/' + themePath + '/quantum/images/logo-mini.png');
    }

    public isActive(path: string) {
        const splittedPath = this.routePath.split('/');

        return path && splittedPath.indexOf(path) !== -1;
    }

    public isVisible(option: any) {
        if (option === null || option === undefined) {
            return true;
        } else {
            return option;
        }
    }

    public get minifyIcon(): string {
        if (this.minify) {
            return 'mdi-chevron-right';
        }

        return 'mdi-chevron-left';
    }

    public get minifyTooltip(): string {
        const output = this.minify ? 'Open' : 'Close';

        return `Click to ${output} Side Menu`;
    }

    public feedbackEvent() {
        this.broadcast({title: 'feedback'});
    }

    public broadcast(item: any) {
        const e = item.title;
        this.$emit(e.toLowerCase());
        if (item.notification && item.notification.dont_clear_on_click) {
            // Do nothing
        } else {
            item.notification = {};
        }
        this.menu_key += 'y';
    }
}
